/* eslint-disable react-hooks/exhaustive-deps */
import configs from "config";
import { useCallback, useMemo, useState } from "react";
import ls from "utils/secureStorage";

function useAuthToken() {
  const [rc, setRc] = useState(0);

  const authToken = useMemo(() => {
    try {
      const tokenStore = ls.get(configs.AUTH_TOKEN_KEY);
      if (tokenStore) {
        const tokenData = JSON.parse(tokenStore) as { token: string; expiry: string };
        if (tokenData.token && new Date() < new Date(tokenData.expiry)) {
          return tokenData.token;
        }
        return null;
      }
    } catch {
      return null;
    }
  }, [rc]);

  const setAuthToken = useCallback(({ token, expiry }: { token: string; expiry: string }) => {
    ls.set(configs.AUTH_TOKEN_KEY, JSON.stringify({ token, expiry }));
  }, []);

  const refreshAuthToken = useCallback(() => {
    setRc((_rc) => _rc + 1);
  }, []);

  return { authToken, setAuthToken, refreshAuthToken };
}

export default useAuthToken;
